import {
  getCustomerStatisticsSummary,
  getOrderStatisticsSummary,
  getPaymentStatisticsSummary,
  getReferrerIncomeStatisticsSummary
} from '@/api/dashboardStatistics'
import { formatAmount, formatGrowthRate, formatInteger } from '../utils/statisticsFormat'

function buildMetric(module, summary = {}) {
  const mainValue = module.valueFormatter(summary[module.valueField])
  const subValue = module.subValueFormatter(summary[module.subValueField])
  const growth = formatGrowthRate(summary[module.growthField])

  return {
    key: module.key,
    title: module.title,
    caption: module.caption,
    value: mainValue,
    valueLabel: module.valueLabel,
    subText: `${module.subLabel} ${subValue}`,
    growthText: growth.text,
    trend: growth.trend,
    loading: false,
    error: false
  }
}

export const dashboardStatisticsModules = [
  {
    key: 'customer',
    title: '客户',
    caption: '新增客户',
    permission: 'customer:statistics:summary',
    summaryApi: getCustomerStatisticsSummary,
    valueField: 'newCount',
    valueFormatter: formatInteger,
    valueLabel: '人',
    subValueField: 'totalCount',
    subValueFormatter: formatInteger,
    subLabel: '累计客户',
    growthField: 'growthRate'
  },
  {
    key: 'order',
    title: '订单',
    caption: '新增订单金额',
    permission: 'order:statistics:summary',
    summaryApi: getOrderStatisticsSummary,
    valueField: 'newAmount',
    valueFormatter: formatAmount,
    valueLabel: '',
    subValueField: 'newCount',
    subValueFormatter: formatInteger,
    subLabel: '新增订单',
    growthField: 'newAmountGrowthRate'
  },
  {
    key: 'payment',
    title: '收款',
    caption: '实收金额',
    permission: 'payment:statistics:summary',
    summaryApi: getPaymentStatisticsSummary,
    valueField: 'collectedAmount',
    valueFormatter: formatAmount,
    valueLabel: '',
    subValueField: 'collectedCount',
    subValueFormatter: formatInteger,
    subLabel: '收款笔数',
    growthField: 'collectedAmountGrowthRate'
  },
  {
    key: 'referrerIncome',
    title: '引入人分账',
    caption: '分账收入',
    permission: 'commission:referrer-income:statistics:summary',
    summaryApi: getReferrerIncomeStatisticsSummary,
    valueField: 'incomeAmount',
    valueFormatter: formatAmount,
    valueLabel: '',
    subValueField: 'pendingAmount',
    subValueFormatter: formatAmount,
    subLabel: '待结算',
    growthField: 'incomeAmountGrowthRate'
  }
]

export function toMetricCard(module, summary) {
  return buildMetric(module, summary)
}

export function toFailedMetricCard(module) {
  return {
    key: module.key,
    title: module.title,
    caption: module.caption,
    value: '--',
    valueLabel: module.valueLabel,
    subText: '加载失败',
    growthText: '加载失败',
    trend: 'neutral',
    loading: false,
    error: true
  }
}

export function toLoadingMetricCard(module) {
  return {
    key: module.key,
    title: module.title,
    caption: module.caption,
    value: '--',
    valueLabel: module.valueLabel,
    subText: '正在加载',
    growthText: '正在更新',
    trend: 'neutral',
    loading: true,
    error: false
  }
}
